import { Fieldset, Grid, NumberInput, Space } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type UpsertProductFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
	prefix?: string; // Form path prefix for when the price fields live on a nested object
};

export function UpsertPriceForm({ form, prefix = '' }: UpsertProductFormProps) {
	const incVatProps = {
		placeholder: 'Insert price including VAT',
		label: 'Price Inc. VAT',
	};

	const excVatProps = {
		placeholder: 'Insert price excluding VAT',
		label: 'Price Exc. VAT',
	};

	const numberInputProps = {
		allowDecimal: true,
		thousandSeparator: ',',
		allowNegative: false,
		prefix: '£',
		decimalScale: 2,
	};

	return (
		<>
			<Fieldset legend={'Price One'}>
				<Grid>
					<Grid.Col span={6}>
						<NumberInput
							{...excVatProps}
							key={form.key(`${prefix}priceExcVatOne`)}
							{...numberInputProps}
							{...form.getInputProps(`${prefix}priceExcVatOne`)}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...incVatProps}
							key={form.key(`${prefix}priceIncVatOne`)}
							{...form.getInputProps(`${prefix}priceIncVatOne`)}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							{...numberInputProps}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>

			<Space h={10} />
			<Fieldset legend={'Price Two'}>
				<Grid>
					<Grid.Col span={6}>
						<NumberInput
							{...excVatProps}
							key={form.key(`${prefix}priceExcVatTwo`)}
							{...numberInputProps}
							{...form.getInputProps(`${prefix}priceExcVatTwo`)}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...incVatProps}
							key={form.key(`${prefix}priceIncVatTwo`)}
							{...form.getInputProps(`${prefix}priceIncVatTwo`)}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							{...numberInputProps}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>

			<Space h={10} />
			<Fieldset legend={'Price Three'}>
				<Grid>
					<Grid.Col span={6}>
						<NumberInput
							{...excVatProps}
							key={form.key(`${prefix}priceExcVatThree`)}
							{...numberInputProps}
							{...form.getInputProps(`${prefix}priceExcVatThree`)}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...incVatProps}
							key={form.key(`${prefix}priceIncVatThree`)}
							{...form.getInputProps(`${prefix}priceIncVatThree`)}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							{...numberInputProps}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>

			<Space h={10} />
			<Fieldset legend={'Price Four'}>
				<Grid>
					<Grid.Col span={6}>
						<NumberInput
							{...excVatProps}
							key={form.key(`${prefix}priceExcVatFour`)}
							{...numberInputProps}
							{...form.getInputProps(`${prefix}priceExcVatFour`)}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...incVatProps}
							key={form.key(`${prefix}priceIncVatFour`)}
							{...form.getInputProps(`${prefix}priceIncVatFour`)}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							{...numberInputProps}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
